import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=320258e6&lang=pug"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=320258e6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports